module.exports = __webpack_public_path__ + "assets/img/custom-sm.50beaab4.jpg";